import {wmsLayer, wmsOrtoLayer, wmsBWLayer, wmsTopo75Layer} from './assets';

 /*new TileLayer({
	title: "KIJS",
//	saturation:0.6,
//	hue:-1.0,
	source: new TileWMS({
		url: location.protocol + '//wms.kartes.lv/' + KIJS + '/wgs/15bw/',
		params: {LAYERS: '0', VERSION: '1.1.1'},
		tileGrid: new TileGrid({
			origin: [-20037508.342787001, -20037508.342787001],
			resolutions: RESOLUTIONS
		}),
		crossOrigin: 'anonymous'
	}),
	visible: true,
});*/



const layerStateMap = {
	jscolor: wmsLayer,
	jsbw: wmsBWLayer,
	orto: wmsOrtoLayer,
	topo75: wmsTopo75Layer
}

var getVisibleLayerID = function() {

	for(var key in layerStateMap) {

		if(layerStateMap[key].getVisible()){
			return key;
		}
	}
}

var setVisibleLayer = function(layer) {
	for(var key in layerStateMap) {

		if(layer == key){
			layerStateMap[key].setVisible(true);
		} else {
			layerStateMap[key].setVisible(false);
		}

	}
}

var customConnect = function(store, params) {


}

export default function(store) {

	store.subscribe(() => {

		var state = store.getState();
		var activeLayer = state.baseLayers.activeLayer;

		if(activeLayer !== getVisibleLayerID()) {


			setVisibleLayer(activeLayer);
		}
	});
}



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/baseLayers/mapContainer.js